"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _WorkspaceActions = require("../actions/WorkspaceActions");

var _SortDirections = _interopRequireDefault(require("settings-ui-lib/constants/SortDirections"));

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  sortCol: 'name',
  sortDir: _SortDirections.default.ASCENDING
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.CONFIRM_WORKSPACE_DELETION, function (state, action) {
  var workspace = action.payload.workspace;
  return state.set('selectedWorkspace', workspace);
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.CANCEL_WORKSPACE_DELETION, function (state) {
  return state.delete('selectedWorkspace');
}), (0, _defineProperty2.default)(_handleActions, _WorkspaceActions.WorkspaceActionTypes.UPDATE_SORT, function (state, action) {
  var currentSortCol = state.get('sortCol');
  var currentSortDir = state.get('sortDir');
  var newSortCol = action.payload.data;

  if (newSortCol === currentSortCol) {
    return state.set('sortDir', currentSortDir * -1);
  }

  return state.merge({
    sortCol: newSortCol,
    sortDir: _SortDirections.default.ASCENDING
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;